import {register} from '../vendor/theme-scripts/theme-sections';
import {swatchGridSection} from '../features/swatch';
import {quickAddProduct} from '../features/quick-add';

register('search', [quickAddProduct, swatchGridSection]);
